require("core-js/modules/es.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.govRouter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var gov = {
    path: '/gov',
    redirect: '/gov/deviceList/:id',
    name: 'DeviceList',
    component: function component() {
      return import('@/Layout');
    },
    meta: {
      title: '设备列表'
    },
    children: [{
      path: 'deviceList/:id',
      component: function component() {
        return import('@/pages/gov/deviceList');
      },
      name: 'DeviceList',
      meta: {
        title: '设备列表'
      }
    }, {
      path: 'circulatingWater/:id',
      component: function component() {
        return import('@/pages/gov/circulatingWater');
      },
      name: 'CirculatingWater',
      meta: {
        title: '塘管家循环水示范基地'
      }
    }, {
      path: 'regionalScreen/:id',
      component: function component() {
        return import('@/pages/gov/regionalScreen');
      },
      name: 'RegionalScreen',
      meta: {
        title: '养殖终端大屏'
      }
    }]
  };
  var _default = gov;
  _exports.default = _default;
});